import React from "react";
import { Route, Routes } from "react-router-dom";
// import BankAccounts from "./Banks/BankAccounts";
// import Cheque from "./Cheque";
// import LoanAccounts from "./LoanAccounts";
import CashInHandAllEffected from "./CashInHandAllEffected";
import BankAccountsAllEffected from "./Banks/BankAccountsAllEffected";
import BankReconciliation from "./BankReconciliation";
import Cheque from "./Cheque";
import ResourceNotFound from "../../Common/ResourceNotFound";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";

const BankingNestedRoute: React.FC = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();
  return (
    <Routes>
      <Route>
        <Route
          path="/bankAccounts"
          element={
            findUserPremission(
              ["Voucher.Contra.View"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Contra],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) ? (
              <BankAccountsAllEffected />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/cashInHand"
          element={
            findUserPremission(
              ["Voucher.Contra.View"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Contra],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) ? (
              <CashInHandAllEffected />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/cheque"
          element={
            findUserOnlyOnePremission(
              "Master.Cheque.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <Cheque />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route
          path="/loanAccounts"
          element={
            findUserOnlyOnePremission(
              "Master.LoanAccounts.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <LoanAccounts />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        /> */}
        <Route
          path="/bankReconciliation"
          element={
            findUserOnlyOnePremission(
              "Master.BankReconciliation.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <BankReconciliation />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
      </Route>
    </Routes>
  );
};
export default BankingNestedRoute;
